<div id="safety-app-vehicle-settings" ng-controller="VehicleSettingsCtrl"></div>